import { render, staticRenderFns } from "./applicationPolicyDeclare.vue?vue&type=template&id=75bb38ee&scoped=true&"
import script from "./applicationPolicyDeclare.vue?vue&type=script&lang=js&"
export * from "./applicationPolicyDeclare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bb38ee",
  null
  
)

export default component.exports